import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";

const styles = {
  root: {
    display: "flex",
    justifyContent: "space-evenly",
    flexWrap: "wrap"
  },
  card: {
    minWidth: 275,
    maxWidth: 200,
    flex: 1,
    margin: 5
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)"
  },
  title: {
    fontSize: 14
  },
  pos: {
    marginBottom: 12
  }
};

function SimpleCard(props) {
  const { classes } = props;

  return (
    <div>
      <Card>
        <CardContent>
          <Typography
            className={classes.title}
            color="textSecondary"
            gutterBottom
          >
            Just visiting this planet
          </Typography>
          <Typography variant="h5" component="h2">
            Manoj Kumar Sahukar
          </Typography>
          <Typography component="p">
            Nilabadi, Bandhugam Block
            <br />
            Koraput, Odisha - 764027, India
            <br />
            Email: manoj.sahukar@gmail.com <br />
            Contact: +919438643108
            <br />
          </Typography>
        </CardContent>
      </Card>
      <br />
    </div>
  );
}

SimpleCard.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(SimpleCard);
